import { render, staticRenderFns } from "./OrganizationSummary.vue?vue&type=template&id=50ada812&scoped=true"
import script from "./OrganizationSummary.vue?vue&type=script&lang=js"
export * from "./OrganizationSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ada812",
  null
  
)

export default component.exports